import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SocialYoutube = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M4 23V9C4 6.237 6.237 4 9 4C9.863 4 10.725 4.225 11.475 4.65L25.5 11.663C27.038 12.55 28 14.213 28 15.988C28 17.763 27.038 19.426 25.5 20.313L25.45 20.338L11.475 27.35C10.725 27.775 9.862 28 9 28C6.237 28 4 25.762 4 23V23ZM24.525 13.412L10.5 6.399C10.05 6.136 9.525 5.999 9 5.999C7.35 5.999 6 7.349 6 8.999V22.999C6 24.649 7.35 25.999 9 25.999C9.525 25.999 10.05 25.862 10.5 25.599L24.525 18.587C25.438 18.049 26 17.062 26 16C26 14.938 25.437 13.95 24.525 13.412V13.412Z" />
	</svg>
);

export default SocialYoutube;
